"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const setupSocket = (client) => {
    var _a, _b, _c;
    const endpoint = `${client._options.ssl ? "https" : "http"}://${client._options.host}`;
    let hostname = (_a = client._options.socketOptions) === null || _a === void 0 ? void 0 : _a.hostname;
    if (!hostname) {
        try {
            hostname = process.env.HOSTNAME || ((_b = require("os")) === null || _b === void 0 ? void 0 : _b.hostname());
        }
        catch (e) { }
    }
    const socket = (0, socket_io_client_1.default)(endpoint, Object.assign(Object.assign({}, (((_c = client._options.socketOptions) === null || _c === void 0 ? void 0 : _c.managerOptions) || {})), { query: {
            token: client.getAccessToken(),
            project: client._options.project,
            env: client._options.env || "master",
            hostname,
        } }));
    socket.on("ping", () => socket.emit("pong"));
    socket.on("replaceUid", () => {
        console.log(`Disconnecting socket ${socket.id} because of duplicate connection ...`);
        socket.close();
    });
    socket.on("/uploads", ({ action, payload }) => {
        const queueItem = client._mediasQueueSubject.value.find((item) => (payload.socket ? item.socket === payload.socket : item.name === payload.name));
        payload.status = action;
        switch (action) {
            case "start":
                client._mediasQueueSubject.next(client._mediasQueueSubject.value.concat(payload));
                break;
            case "end":
            case "aborted":
            case "progress":
            case "error":
                client._mediasQueueSubject.next(client._mediasQueueSubject.value.map((item) => (item === queueItem ? Object.assign(item, payload) : item)));
                break;
        }
    });
    socket.on("connect", () => client._socketSubject.next(socket));
    socket.on("disconnect", () => client._socketSubject.next(null));
    socket.on("connect_error", (e) => console.error("connect_error", e));
    socket.on("reconnect_error", (e) => console.error("reconnect_error", e));
    socket.on("reconnect_failed", (e) => console.error("reconnect_failed", e));
    socket.on("connect_timeout", (e) => console.error("connect_timeout", e));
    return socket;
};
exports.default = setupSocket;
